export enum QUERY_NAME {
  fetchBookmarks = 'fetchBookmarks',
  fetchBookmarksCount = 'fetchBookmarksCount',
  fetchBookmarksFilters = 'fetchBookmarksFilters',
}
